<template>
    <b-modal id="edit_cron_subscriber_modal" @ok="editCronSubscriber">
        <template slot="modal-title">Edit a cron subscriber</template>
        <form ref="edit_cron_subscriber_form">
            <b-form-group
                    label="Name"
                    label-for="name">
                <b-form-input
                        id="name"
                        :state="validateName"
                        v-model="selected_cron_subscriber.name"
                        autofocus
                        required/>
                <b-form-invalid-feedback :state="validateName">
                    Name is invalid, it needs at least {{minNameLength}} characters.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
                    label="Interval in minutes"
                    label-for="interval">
                <b-form-input
                        id="interval"
                        :state="validateInterval"
                        v-model="selected_cron_subscriber.interval"
                        type="number"
                        required/>
                <b-form-invalid-feedback :state="validateInterval">
                    Interval is invalid.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
                    label="Active"
                    label-for="active">
                <b-form-checkbox
                        id="active"
                        v-model="selected_cron_subscriber.active"
                        required/>
            </b-form-group>
            <b-form-group
                    label="Event to fire"
                    label-for="event">
                <b-form-select
                        id="event"
                        :state="validateEvent"
                        v-model="selected_cron_subscriber.event_name"
                        :options="event_options"
                        required/>
                <b-form-invalid-feedback :state="validateEvent">
                    Select an event.
                </b-form-invalid-feedback>
            </b-form-group>
        </form>
    </b-modal>
</template>

<script>
    import CronSubscriberRepository from '../../repositories/cron_subscriber.repository';

    export default {
        props: {
            event_options: {
                type: Array,
                default: () => []
            },
            selected_cron_subscriber: {
                type: Object,
                default: CronSubscriberRepository.blankSubscriber
            }
        },
        data() {
            return {minNameLength: process.env.VUE_APP_VALIDATION_CRONSUBSCRIBER_MIN_NAME_LENGTH}
        },
        methods: {
            checkFields() {
                if (CronSubscriberRepository.validate.name(this.selected_cron_subscriber.name) === false) return false;
                if (CronSubscriberRepository.validate.interval(this.selected_cron_subscriber.interval) === false) return false;
                if (CronSubscriberRepository.validate.event(this.selected_cron_subscriber.event_name) === false) return false;
                return true;
            },
            editCronSubscriber(modal) {
                if (this.$refs.edit_cron_subscriber_form.checkValidity() && this.checkFields()) {
                    this.$emit('show-loading-pop-up', 'Saving the changes to the selected cron subscriber.');
                    CronSubscriberRepository.put(this.selected_cron_subscriber.id, this.selected_cron_subscriber).then(res => {
                        this.$emit('reset-loading-pop-up');
                        this.$emit('cron-subscriber-edited', res.data);
                        // Notify the user.
                        this.$bvToast.toast(`Cron subscriber ${res.data.name} successfully edited.`, {
                            title: `Cron subscriber edited.`,
                            variant: 'success',
                            solid: true
                        });
                    }).catch(error => {
                        this.$emit('reset-loading-pop-up');
                        if (error.response.status === 422) {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText + " \n details:" + error.response.data['hydra:description']);
                            this.$bvToast.toast('Looks like something went wrong while validating the new cron subscriber. Check the value\'s of all the fields', {
                                title: `cron subscriber creation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText);
                            this.$bvToast.toast('Looks like something went wrong on the server while creating a new cron subscriber.', {
                                title: `cron subscriber edit error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    });
                } else {
                    modal.preventDefault();
                }
            }
        },
        computed: {
            validateName() {
                return CronSubscriberRepository.validate.name(this.selected_cron_subscriber.name);
            },
            validateInterval() {
                return CronSubscriberRepository.validate.interval(this.selected_cron_subscriber.interval);
            },
            validateProject() {
                return CronSubscriberRepository.validate.interval(this.selected_cron_subscriber.project_id);
            },
            validateEvent() {
                return CronSubscriberRepository.validate.event(this.selected_cron_subscriber.event_name);
            }
        }
    }
</script>
